import React from "react";
import { Box } from "@twilio-paste/core";
import { Tooltip } from "@twilio-paste/tooltip";

type ConversationBadgeProps = {
  unreadCount: number;
  showTransferBadge: boolean;
};

export const ConversationBadge: React.FC<ConversationBadgeProps> = ({
  unreadCount,
  showTransferBadge,
}) => {
  const hasUnread = unreadCount > 0;
  const unreadLabel =
    unreadCount > 99 ? "99+" : hasUnread ? unreadCount.toString() : "";

  return (
    <>
      {hasUnread && (
        <Box
          as="span"
          position="absolute"
          top="-4px"
          right="-6px"
          minWidth="18px"
          height="18px"
          paddingX="space10"
          borderRadius="borderRadiusCircle"
          backgroundColor="colorBackgroundDestructive"
          color="colorTextInverse"
          fontSize="fontSize20"
          fontWeight="fontWeightSemibold"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {unreadLabel}
        </Box>
      )}

      {showTransferBadge && (
        <Tooltip text="Conversazione trasferita">
          <Box
            as="span"
            position="absolute"
            bottom="-2px"
            right="-2px"
            width="10px"
            height="10px"
            borderRadius="borderRadiusCircle"
            backgroundColor="colorBackgroundWarning"
          />
        </Tooltip>
      )}
    </>
  );
};
